import "../../FhTitle.css";
import { useSlots, computed, openBlock, createElementBlock, normalizeClass, createVNode, mergeProps, withCtx, renderSlot, unref, createBlock, createCommentVNode } from "vue";
import FhText from "../FhText/FhText.mjs";
import { TAGS_ENUMS, VARIANTS_ENUMS } from "./constants.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhTitle",
  props: {
    tag: {
      type: String,
      default: TAGS_ENUMS.H1,
      validator: (value) => Object.values(TAGS_ENUMS).includes(value)
    },
    variant: {
      type: String,
      default: VARIANTS_ENUMS.DISPLAY_3XL,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const computedSubtitleVariant = computed(() => {
      return props.variant === "display-3xl" ? "body-lg" : "body-md";
    });
    const computedTitleClasses = computed(() => [
      "fh-title",
      `fh-title--${props.variant}`
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(computedTitleClasses.value)
      }, [
        createVNode(FhText, mergeProps({
          tag: props.tag,
          variant: props.variant
        }, _ctx.$attrs), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 16, ["tag", "variant"]),
        unref(slots).subtitle ? (openBlock(), createBlock(FhText, {
          key: 0,
          variant: computedSubtitleVariant.value,
          color: "subtle"
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "subtitle", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["variant"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const FhTitle = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c3de7234"]]);
export {
  FhTitle as default
};
//# sourceMappingURL=FhTitle.mjs.map
